import { Box, ClickAwayListener, styled, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { useState } from "react";
import { isBrowser } from "react-device-detect";
import { isNullOrEmpty } from "../common/common";

const HtmlTooltip = styled(({ open, handleTooltipClose, className, ...props }: any) => {
  let tooltipProps: any = {};
  if (!isBrowser) {
    tooltipProps.open = open;
    tooltipProps.disableFocusListener = true;
    tooltipProps.disableHoverListener = true;
    tooltipProps.disableTouchListener = true;
  }
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        {...tooltipProps}
        onClose={handleTooltipClose}
        {...props}
        classes={{ popper: className }}
        slotProps={{
          popper: {
            sx: {
              [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
                marginTop: "0px",
                marginRight: "16px",
                marginLeft: "16px",
              },
              [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
                marginBottom: "0px",
                marginRight: "16px",
                marginLeft: "16px",
              },
              [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]: {
                marginRight: "16px",
                marginLeft: "16px",
              },
              [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]: {
                marginRight: "16px",
                marginLeft: "16px",
              },
            },
          },
        }}
      />
    </ClickAwayListener>
  );
})(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    maxWidth: 328,
    boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
  },
}));

interface tooltipProps {
  icon?: any;
  tooltipText: string;
  text?: any;
}

export const TooltipMUI = ({ icon, tooltipText, text }: tooltipProps) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <HtmlTooltip
      handleTooltipClose={handleTooltipClose}
      open={open}
      title={
        <Box className="text-primary" sx={{ padding: "14px" }}>
          <Typography variant="subtitle2">{tooltipText}</Typography>
        </Box>
      }
    >
      <Box className="display-flex-center" onClick={handleTooltipOpen}>
        {!isNullOrEmpty(text) && (
          <Typography variant="subtitle1" className="text-primary" sx={{ cursor: "pointer" }}>
            {text}
          </Typography>
        )}
        {!isNullOrEmpty(icon) && <Box>{icon}</Box>}
      </Box>
    </HtmlTooltip>
  );
};
